import axios from 'axios';

const axiosCodeigniter = axios.create({
    baseURL: process.env.REACT_APP_CODEIGNITER_BASE_URL
});

export default axiosCodeigniter